import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { translate } from 'parking-react-common'
import { map, isFunction } from 'lodash'

import { api, ui } from '../redux'

import Button from '../components/Button'

const GateButton = ({ dispatch, gate, t }) => {
    const buttons = [
        {
            label   : 'In',
            icon    : 'md/local-parking',
            intent  : ui.INTENT.warning,
            onClick : () => api.update(gate.url, { opened: true, requested_direction: 'in' })
        },
        {
            label   : 'Out',
            icon    : 'md/directions-car',
            intent  : ui.INTENT.success,
            onClick : () => api.update(gate.url, { opened: true, requested_direction: 'out' })
        }
    ]

    const action = gate.direction === 'both'
        ? ui.showModal({
            title   : t('Choose gate direction'),
            intent  : ui.INTENT.primary,
            content : (
                <div>
                    { map(buttons, (item, key) => (
                        <Button
                            key={ `action-button-${key}` }
                            { ...item }
                            onClick={ () => {
                                if (isFunction(item.onClick)) {
                                    dispatch(item.onClick())
                                }
                                dispatch(ui.closeModal())
                            } }
                            size="default"
                        />
                    )) }
                </div>
            )
        })
        : api.update(gate.url, { opened: true, requested_direction: gate.direction })

    return (
        <Button
            onClick={ () => dispatch(action) }
            intent={ ui.INTENT.success }
            size={ ui.SIZE.large }
            icon="md/lock-open"
        />
    )
}

GateButton.propTypes = {
    gate     : PropTypes.object,
    dispatch : PropTypes.func.isRequired
}

export default translate()(connect()(GateButton))
